import React from 'react';
import {useTranslation} from 'react-i18next';

import {Tr} from '@edna/components';

import ReportTable from 'src/components/ReportTable';
import {parseISO} from 'src/utils';

import {TBilledEventData} from '../definitions';
import * as S from '../style';

const BILLED_EVENT_TABLE_COLUMNS_WIDTH = ['15%', '35%', '20%', '15%', '15%'];
const DEBT_TRANSACTION_TABLE_COLUMNS_WIDTH = [
  '10%',
  '10%',
  '10%',
  '15%',
  '15%',
  '10%',
  '10%',
  '10%',
  '10%',
];
const TRANSACTION_TABLE_COLUMNS_WIDTH = [
  '8%',
  '8%',
  '8%',
  '14%',
  '14%',
  '8%',
  '8%',
  '8%',
  '8%',
  '8%',
  '8%',
];

export const BilledEventData = React.memo<{data: TBilledEventData}>(({data}) => {
  const {t} = useTranslation();

  const {billedEvent, debtTransaction, transaction} = data;

  return (
    <S.BilledEventTables>
      {billedEvent && (
        <ReportTable
          isScroll
          label={t('Corrections:payments.storno.billedEvent')}
          columnsWidth={BILLED_EVENT_TABLE_COLUMNS_WIDTH}
        >
          <Tr>
            <S.BillTh>{t('Corrections:payments.storno.id')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.originalEventId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.originalEventType')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.confirmation')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.createdAt')}</S.BillTh>
          </Tr>
          <Tr>
            <S.BillTd>{billedEvent.id}</S.BillTd>
            <S.BillTd>{billedEvent.originalEventId}</S.BillTd>
            <S.BillTd>{billedEvent.originalEventType}</S.BillTd>
            <S.BillTd>{billedEvent.confirmation}</S.BillTd>
            <S.BillTd>{parseISO(billedEvent.createdAt, 'dd.MM.yyyy, HH:mm')}</S.BillTd>
          </Tr>
        </ReportTable>
      )}
      {debtTransaction && (
        <ReportTable
          isScroll
          label={t('Corrections:payments.storno.debtTransaction')}
          columnsWidth={DEBT_TRANSACTION_TABLE_COLUMNS_WIDTH}
        >
          <Tr>
            <S.BillTh>{t('Corrections:payments.storno.id')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.eventId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.tenantId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.reason')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.reasonCode')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.balanceId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.amount')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.currency')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.createdAt')}</S.BillTh>
          </Tr>
          <Tr>
            <S.BillTd>{debtTransaction.id}</S.BillTd>
            <S.BillTd>{debtTransaction.eventId}</S.BillTd>
            <S.BillTd>{debtTransaction.tenantId}</S.BillTd>
            <S.BillTd>{debtTransaction.reason}</S.BillTd>
            <S.BillTd>{debtTransaction.reasonCode}</S.BillTd>
            <S.BillTd>{debtTransaction.balanceId}</S.BillTd>
            <S.BillTd>{debtTransaction.amount}</S.BillTd>
            <S.BillTd>{debtTransaction.currency}</S.BillTd>
            <S.BillTd>{parseISO(debtTransaction.createdAt, 'dd.MM.yyyy, HH:mm')}</S.BillTd>
          </Tr>
        </ReportTable>
      )}
      {transaction && (
        <ReportTable
          isScroll
          label={t('Corrections:payments.storno.transaction')}
          columnsWidth={TRANSACTION_TABLE_COLUMNS_WIDTH}
        >
          <Tr>
            <S.BillTh>{t('Corrections:payments.storno.id')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.eventId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.tenantId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.reason')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.reasonCode')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.balanceId')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.openingBalance')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.amount')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.currency')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.createdAt')}</S.BillTh>
            <S.BillTh>{t('Corrections:payments.storno.state')}</S.BillTh>
          </Tr>
          <Tr>
            <S.BillTd>{transaction.id}</S.BillTd>
            <S.BillTd>{transaction.eventId}</S.BillTd>
            <S.BillTd>{transaction.tenantId}</S.BillTd>
            <S.BillTd>{transaction.reason}</S.BillTd>
            <S.BillTd>{transaction.reasonCode}</S.BillTd>
            <S.BillTd>{transaction.balanceId}</S.BillTd>
            <S.BillTd>{transaction.openingBalance}</S.BillTd>
            <S.BillTd>{transaction.amount}</S.BillTd>
            <S.BillTd>{transaction.currency}</S.BillTd>
            <S.BillTd>{parseISO(transaction.createdAt, 'dd.MM.yyyy, HH:mm')}</S.BillTd>
            <S.BillTd>{transaction.state}</S.BillTd>
          </Tr>
        </ReportTable>
      )}
    </S.BilledEventTables>
  );
});

BilledEventData.displayName = 'BilledEventData';
